import React from "react";
import SidebarComponent from "../sideMenu";
import HeaderComponent from "../navigationBar";
import Header from "./components/Header";

const NewBookingComponent = () => {

    return(
        <>
            <HeaderComponent/>
            <SidebarComponent/>
            <Header/>
        </>
    )
}

export default NewBookingComponent;